import React from "react";
var __jsx = React.createElement;
var ArrowDownSVG = function ArrowDownSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#154F9C" : _ref$filledColor,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className ? className : ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11953 14.7099L11.9995 10.8299L15.8795 14.7099C16.2695 15.0999 16.8995 15.0999 17.2895 14.7099C17.6795 14.3199 17.6795 13.6899 17.2895 13.2999L12.6995 8.70994C12.3095 8.31994 11.6795 8.31994 11.2895 8.70994L6.69953 13.2999C6.30953 13.6899 6.30953 14.3199 6.69953 14.7099C7.08953 15.0899 7.72953 15.0999 8.11953 14.7099Z",
    fill: filledColor
  }));
};
export default ArrowDownSVG;